$(function ($) {

  $('.program-select .selected').on('click', function(e) {
    e.preventDefault();
    $('.program-select').toggleClass('open');
  })

});
